/**
 * BBI — Bullish-Bearish Index.
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLTrend.cs, classe FML.BBI):
 *
 *   BBI = (MA(C,N1) + MA(C,N2) + MA(C,N3) + MA(C,N4)) / 4
 *
 * MA(f,N) é a média aritmética do engine (silverlightDsl.ma — soma corrida com
 * as regras de NaN do original; N=0 = média cumulativa). Warm-up: NaN até
 * max(N1..N4)−1 barras. Paridade provada em __tests__/bbi.silverlight.test.js.
 */
import { getSourcePathAccessor } from "../utils";
import { ma, add, div } from "./silverlightDsl";
import { BBI as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { n1, n2, n3, n4, sourcePath } = options;

    const source = getSourcePathAccessor(sourcePath);
    const c = data.map((d, i) => {
      const v = source(d, i);
      return Number.isFinite(v) ? v : NaN;
    });

    // (MA(C,N1) + MA(C,N2) + MA(C,N3) + MA(C,N4)) / 4 — mesma ordem do engine.
    const bbi = div(
      add(add(add(ma(c, n1), ma(c, n2)), ma(c, n3)), ma(c, n4)),
      4,
    );

    // Borda com o chart: NaN (warm-up / dado ausente) vira undefined.
    return bbi.map((v) => (Number.isFinite(v) ? v : undefined));
  }

  calculator.undefinedLength = function () {
    const { n1, n2, n3, n4 } = options;
    return Math.max(0, Math.max(n1, n2, n3, n4) - 1);
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
